export default __webpack_public_path__ + "static/media/3669_124693.d6e3755b.svg";